import Head from 'next/head'
import Link from 'next/link'
import Header from '../src/local/Header'
import ErrorBoundary from '../src/local/ErrorBoundary'
import s from '../styles/RedesignTelepulesek.module.css'
import { CITY_COORDS, MAP_SRC, VIEWBOX } from '../src/data/hungaryMap'

const PinSvg = () => <svg viewBox="0 0 24 24" fill="white"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" /></svg>

const cities = [
  { name: 'Üllő', county: 'Pest vármegye', tags: ['Hírek','Önkormányzat'], active: true },
  { name: 'Balatonszentgyörgy', county: 'Somogy vármegye', tags: ['Hírek','Közlemények'] },
  { name: 'Alsómocsolád', county: 'Baranya vármegye', tags: ['Hírek','Események'] },
  { name: 'Gyömrő', county: 'Pest vármegye', tags: ['Hírek','Önkormányzat'] },
  { name: 'Gádoros', county: 'Békés vármegye', tags: ['Hírek','Önkormányzat'] },
]

const coming = [
  { name: 'Szentistván', sub: 'Hamarosan' },
]

export default function Telepulesek() {
  const currentYear = new Date().getFullYear()

  return (
    <ErrorBoundary>
      <div className={s.site}>
        <Head><title>HolmiApp – Települések</title></Head>
        <Header />

        {/* PAGE HEADER */}
        <div className={s.pageHeader}>
          <div className={s.eyebrow}><span className={s.eyebrowDot} />Elérhető helyszínek</div>
          <h1 className={s.pageTitle}>Aktív települések</h1>
          <p className={s.pageSub}>A HolmiApp jelenleg 4 magyarországi településen érhető el. Az önkormányzatokkal együttműködve folyamatosan bővítjük a kört.</p>
        </div>

        {/* STATS */}
        <div className={s.statsRow}>
          <div className={s.statCard}><div className={s.statLabel}>Aktív település</div><div className={s.statValue}>5</div></div>
          <div className={s.statCard}><div className={s.statLabel}>Lefedett vármegye</div><div className={s.statValue}>4</div></div>
          <div className={s.statCard}><div className={s.statLabel}>Hamarosan csatlakozik</div><div className={s.statValue}><span>+</span>1</div></div>
        </div>

        {/* MAIN BODY */}
        <div className={s.mainBody}>
          {/* MAP */}
          <div className={s.mapArea}>
            <div className={s.areaLabel}>Magyarország térképe</div>
            <div className={s.mapWrap}>
              <svg
                viewBox={`0 0 ${VIEWBOX.width} ${VIEWBOX.height}`}
                xmlns="http://www.w3.org/2000/svg"
                aria-label="Magyarország térképe"
                className={s.mapSvg}
              >
                <image
                  href={MAP_SRC}
                  width={VIEWBOX.width}
                  height={VIEWBOX.height}
                  preserveAspectRatio="xMidYMid meet"
                />

                <circle
                  cx={CITY_COORDS.Budapest.cx}
                  cy={CITY_COORDS.Budapest.cy}
                  r={10}
                  fill="#1A2E4A"
                  opacity="0.55"
                />
                <text
                  x={CITY_COORDS.Budapest.cx}
                  y={CITY_COORDS.Budapest.cy - 14}
                  textAnchor="middle"
                  fontSize="22"
                  fill="#1A2E4A"
                  fontFamily="Plus Jakarta Sans, sans-serif"
                  fontWeight="500"
                  opacity="0.7"
                >
                  Budapest
                </text>

                {cities.map(city => {
                  const coords = CITY_COORDS[city.name]
                  if (!coords) return null
                  return (
                    <g key={city.name}>
                      <circle cx={coords.cx} cy={coords.cy} r={22} fill="#27AE78" opacity="0.18" />
                      <circle cx={coords.cx} cy={coords.cy} r={12} fill="#27AE78" />
                      <circle cx={coords.cx} cy={coords.cy} r={5} fill="#fff" />
                      <text
                        x={coords.cx}
                        y={coords.cy - 18}
                        textAnchor="middle"
                        fontSize="24"
                        fill="#1A2E4A"
                        fontFamily="Plus Jakarta Sans, sans-serif"
                        fontWeight="700"
                      >
                        {city.name}
                      </text>
                    </g>
                  )
                })}

                {coming.map(item => {
                  const coords = CITY_COORDS[item.name]
                  if (!coords) return null
                  return (
                    <g key={item.name}>
                      <circle cx={coords.cx} cy={coords.cy} r={22} fill="#F2F4F8" />
                      <circle cx={coords.cx} cy={coords.cy} r={10} fill="#6B7A8D" />
                      <text
                        x={coords.cx}
                        y={coords.cy - 18}
                        textAnchor="middle"
                        fontSize="24"
                        fill="#1A2E4A"
                        fontFamily="Plus Jakarta Sans, sans-serif"
                        fontWeight="700"
                      >
                        {item.name}
                      </text>
                    </g>
                  )
                })}
              </svg>
            </div>
          </div>

          {/* SIDEBAR */}
          <div className={s.sidebar}>
            <div className={s.sidebarLabel}>Aktív városok</div>
            {cities.map(city => (
              <div key={city.name} className={`${s.cityCard} ${city.active ? s.cityCardActive : ''}`}>
                <div className={s.cityTop}>
                  <div className={s.cityIcon}><PinSvg /></div>
                  <div><div className={s.cityName}>{city.name}</div><div className={s.cityCounty}>{city.county}</div></div>
                </div>
                <div className={s.cityTags}>{city.tags.map(t => <span key={t} className={s.cityTag}>{t}</span>)}</div>
              </div>
            ))}
            <div className={s.comingSection}>
              <div className={s.sidebarLabel}>Hamarosan</div>
              {coming.map(item => (
                <div key={item.name} className={s.comingCard}>
                  <div className={s.comingIcon}>+</div>
                  <div><div className={s.comingName}>{item.name}</div><div className={s.comingSub}>{item.sub}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA STRIP */}
        <div className={s.ctaStrip}>
          <div className={s.ctaText}><strong>Nincs még a listán a városod?</strong> Kérd meg az önkormányzatodat, hogy csatlakozzanak a HolmiApp platformhoz.</div>
          <Link href="/Onkormanyzat" className={s.ctaBtn}>Önkormányzatoknak →</Link>
        </div>

        {/* FOOTER */}
        <footer className={s.footer}>
          <span className={s.footerLogo}>HolmiApp</span>
          <div className={s.footerLinks}><Link href="/Bemutato">Bemutató</Link><Link href="/Telepulesek">Települések</Link><Link href="/Onkormanyzat">Önkormányzat</Link><Link href="/Galeria">Galéria</Link></div>
          <span className={s.footerCopy}>© {currentYear} HolmiApp. Minden jog fenntartva.</span>
        </footer>
      </div>
    </ErrorBoundary>
  )
}
